import { Divider, Stack, type StackProps, styled } from "@mui/material";

export const FilterSearchContainer = styled((props: StackProps) => (
  <Stack
    divider={
      <Divider
        flexItem
        orientation="vertical"
        variant="middle"
        sx={(theme) => ({
          backgroundColor: theme.palette.grey[400],
        })}
      />
    }
    {...props}
  />
))(({ theme }) => ({
  flexDirection: "row",
  justifyContent: "flex-start",
  border: `1px solid ${theme.palette.grey[400]}`,
  backgroundColor: theme.palette.background.paper,
  ":hover": {
    borderColor: theme.palette.grey[500],
  },
}));
